export default "__VITE_ASSET__2WAV0Bwx__"